// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"vy_a bhb_b","TwoDimsListFeature__item":"vy_b bhb_ux","TwoDimsListFeature__item__text":"vy_c bhb_un"};